import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { disabled, form, FormField, required } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CURRENCY_OPTIONS, CurrencyDto } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '../../../../abstract';

@Component({
  selector: 'aura-internationalization-currency-form',
  templateUrl: './internationalization-currency-form.component.html',
  imports: [FormField, MatFormFieldModule, MatSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraInternationalizationCurrencyFormComponent extends AbstractSignalFormComponent<CurrencyDto> {
  override model: WritableSignal<CurrencyDto> = signal<CurrencyDto>({ currency: 'EUR' });
  currencies = CURRENCY_OPTIONS;

  override formTree = form(this.model, (b) => {
    required(b.currency, { when: () => this.isRequired('currency') });
    disabled(b.currency, { when: () => this.allReadonly() || this.allDisable() });
  });
}
